// @flow @format
import {combineReducers} from 'redux';
import users, {initialState as usersInitialState} from './users';
import machines, {initialState as machinesInitialState} from './machines';
import repositories, {initialState as repositoriesInitialState} from './repositories';
import files, {initialState as filesInitialState} from './files';
import downloads, {initialState as downloadsInitialState} from './downloads';

import type {State as UsersState} from './users';
import type {State as MachinesState} from './machines';
import type {State as FilesState} from './files';
import type {State as DownloadsState} from './downloads';
import type {State as RepositoriesState} from './repositories';

export type State = {
	users: UsersState,
	machines: MachinesState,
	repositories: RepositoriesState,
	files: FilesState,
	downloads: DownloadsState,
};

export const initialState = {
	users: usersInitialState,
	machines: machinesInitialState,
	repositories: repositoriesInitialState,
	files: filesInitialState,
	downloads: downloadsInitialState,
};

export default combineReducers({
	users,
	machines,
	repositories,
	files,
	downloads,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/index.js